import { css } from 'styled-components'

export const effectStyle = css`
  effect {
    display: inline-flex;
    align-items: center;

    position: relative;

    vertical-align: bottom;
    border-radius: 4px;
    height: 24px;
    padding: 4px 10px;
    border: 1px solid #dddddd;

    background-color: #f6c138;
    box-shadow: 0px 0px 6px 0px #0000001a;

    font-size: 12px;
    color: #ffffff;

    cursor: pointer;

    &::before {
      align-self: start;
      content: url('/images/icon/icon_editor_effect.svg');

      vertical-align: center;
      margin-right: 5px;
      line-height: 17px;
    }

    /**
     * like disabled
     */
    &.disconnected {
      background-color: #aaaaaa;
    }

    & > span {
      display: flex;
      gap: 4px;
    }

    .order {
      font-weight: 600;
    }
  }
`
